// extracted by mini-css-extract-plugin
module.exports = {"resume__content":"style_resume__content__YHOkQ","resume__main":"style_resume__main__3dsys","resume__image":"style_resume__image__1zlWX"};